import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ManageRidersComponent from '@app/components/manage-rider/list';

const ManageRider: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Rider</PageTitle>
      <ManageRidersComponent />
    </>
  );
};

export default ManageRider;
